/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
// eslint-disable-next-line
import React from 'react'

import { SmallText } from '../presentation/Text'

const ListGroup = ({ title, children, bgColor, noMargin, align }) => {
  const style = css`
    ${noMargin ? '' : 'margin-bottom: 1rem;'}

    & > .titleWrapper {
      padding: 0.2rem 1rem;
      background: ${bgColor || COLORS.light3};
    }
  `

  return (
    <div className="listGroup" css={style}>
      <div className="titleWrapper">
        <SmallText size="xsmall" align={align || 'center'} bold color={COLORS.dark3}>
          {title}
        </SmallText>
      </div>
      {children}
    </div>
  )
}

export default ListGroup
